// extracted by mini-css-extract-plugin
var _1 = "EmbeddedPostView-module__animateUploadProgressBarWidth--o_fv3";
var _2 = "EmbeddedPostView-module__animatedBackground--qAOGM";
var _3 = "EmbeddedPostView-module__container--kp9wl";
var _4 = "EmbeddedPostView-module__content--aulBp";
var _5 = "EmbeddedPostView-module__editorContainer--tW0Wj";
var _6 = "EmbeddedPostView-module__editorRoot--RxQ0s";
var _7 = "EmbeddedPostView-module__footer--L9gfn";
var _8 = "EmbeddedPostView-module__fullWidthContainer--v3dJk";
var _9 = "EmbeddedPostView-module__isActive--SoSA4";
var _a = "EmbeddedPostView-module__logo--kln8D";
var _b = "EmbeddedPostView-module__logoAndTitle--XiLcz";
var _c = "EmbeddedPostView-module__overlay--MricE";
var _d = "EmbeddedPostView-module__postContainer--VCz1S";
var _e = "EmbeddedPostView-module__title--_M8UA";
var _f = "EmbeddedPostView-module__tocButton--put4d";
var _10 = "EmbeddedPostView-module__tocContainer--wR7us";
var _11 = "EmbeddedPostView-module__tocContent--D988q";
var _12 = "EmbeddedPostView-module__tocTitle--Ji5Ep";
var _13 = "150";
var _14 = "ease";
var _15 = "200px";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "content", _5 as "editorContainer", _6 as "editorRoot", _7 as "footer", _8 as "fullWidthContainer", _9 as "isActive", _a as "logo", _b as "logoAndTitle", _c as "overlay", _d as "postContainer", _e as "title", _f as "tocButton", _10 as "tocContainer", _11 as "tocContent", _12 as "tocTitle", _13 as "tocTransitionDuration", _14 as "tocTransitionTimingFunction", _15 as "tocWidth" }
